// // src/App.js
// import React, { useEffect } from "react";
// import { Routes, Route } from "react-router-dom";
// import { useAuth0 } from "@auth0/auth0-react";
// import HomePage from "./components/home-page-component/HomePage";
// import AboutPage from "./components/about-page-component/AboutPage";
// import ProfilePage from "./components/profile-page-component/ProfilePage";
// import Layout from "./components/layout-component/Layout";
// import { getUserProfile } from "./api/userApi";
// import CallbackPage from "./components/calllback-page/CallbackPage";
// import StepperPage from "./components/stepper-create-my-book/StepperPage";
// import PurchaseSuccess from "./components/stepper-create-my-book/steps/PurchaseSuccess";
// import AdminPanel from "./components/admin/AdminPanel";
// import Pricing from "./components/pricing-page-component/Pricing";
// import Contacts from "./components/contacts-page-component/Contacts";
// import HowItWorks from "./components/how-it-works/HowItWorks";



// function App() {
//   const { isAuthenticated, getAccessTokenSilently } = useAuth0();

//   // Автоматично створюємо/оновлюємо юзера в базі після логіну
//   useEffect(() => {
//     const createOrUpdateUser = async () => {
//       try {
//         const token = await getAccessTokenSilently();
//         await getUserProfile(token); // виклик /auth/profile
//       } catch (error) {
//         console.error("Помилка створення/оновлення користувача:", error);
//       }
//     };

//     if (isAuthenticated) {
//       createOrUpdateUser();
//     }
//   }, [isAuthenticated, getAccessTokenSilently]);

//   return (
//     <Layout>
//       <Routes>
//         {/* <Route path="/" element={<HomePage />} /> */}
//         <Route path="/about-custom-fable" element={<AboutPage />} />
//         <Route path="/profile" element={<ProfilePage />} />
//         <Route path="/auth/callback" element={<CallbackPage />} />
//         <Route path="/stepper" element={<StepperPage />} />
//         <Route path="/purchase-success" element={<PurchaseSuccess />} />
//         <Route path="/admin" element={<AdminPanel />} />
//         <Route path="/pricing" element={<Pricing />} />
//         <Route path="/contacts" element={<Contacts />} />
//         <Route path="/" element={<HowItWorks />} />
//       </Routes>
      
//     </Layout>
//   );
// }

// export default App;





// src/App.js
import React, { useEffect, lazy, Suspense } from "react"; // <--- ДОДАНО lazy, Suspense
import { Routes, Route } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, CircularProgress } from "@mui/material"; // <--- ДОДАНО для спінера

// --- СТАТИЧНІ ІМПОРТИ ---
// Layout та API-клієнти мають завантажуватись одразу
import Layout from "./components/layout-component/Layout";
import { getUserProfile } from "./api/userApi";
import './i18n';

// --- "ЛІНИВІ" ІМПОРТИ СТОРІНОК ---
// Всі ці компоненти тепер будуть завантажені
// лише тоді, коли користувач на них перейде.
const HomePage = lazy(() => import("./components/home-page-component/HomePage"));
const AboutPage = lazy(() => import("./components/about-page-component/AboutPage"));
const ProfilePage = lazy(() => import("./components/profile-page-component/ProfilePage"));
const CallbackPage = lazy(() => import("./components/calllback-page/CallbackPage"));
const StepperPage = lazy(() => import("./components/stepper-create-my-book/StepperPage"));
const PurchaseSuccess = lazy(() => import("./components/stepper-create-my-book/steps/PurchaseSuccess"));
const AdminPanel = lazy(() => import("./components/admin/AdminPanel"));
const Pricing = lazy(() => import("./components/pricing-page-component/Pricing"));
const Contacts = lazy(() => import("./components/contacts-page-component/Contacts"));
const HowItWorks = lazy(() => import("./components/how-it-works/HowItWorks"));


// --- КОМПОНЕНТ ЗАГЛУШКИ (СПІНЕР) ---
// Цей компонент буде показано, поки завантажується "лінивий" шматок коду
const PageLoader = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
    <CircularProgress sx={{ color: '#7A3CFF' }} /> 
  </Box>
);


function App() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  // Ваш useEffect залишається БЕЗ ЗМІН
  useEffect(() => {
    const createOrUpdateUser = async () => {
      try {
        const token = await getAccessTokenSilently();
        await getUserProfile(token); // виклик /auth/profile
      } catch (error) {
        console.error("Помилка створення/оновлення користувача:", error);
      }
    };

    if (isAuthenticated) {
      createOrUpdateUser();
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return (
    <Layout>
      {/* --- ОБГОРТКА SUSPENSE --- */}
      {/* "fallback" - це те, що бачить юзер, поки сторінка вантажиться */}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/about-custom-fable" element={<AboutPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/auth/callback" element={<CallbackPage />} />
          <Route path="/stepper" element={<StepperPage />} />
          <Route path="/purchase-success" element={<PurchaseSuccess />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/" element={<HowItWorks />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;